import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { StorageProgress } from '../../../features/settings/components/storage-progress';
import { uiStore } from '../../../core/stores/ui-store';
import { useCurrentSpace } from '../../../hooks/use-current-space';
import { SettingScreenLayout } from '../../../features/settings/components/setting-screen-layout';

import styles from './storage-settings.route.module.scss';
export const StorageSettingsRoute: React.FC = observer(() => {
  const space = useCurrentSpace();

  useEffect(() => {
    uiStore.showBack = true;

    uiStore.currentLocation = 'space.settings';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  return (
    <SettingScreenLayout title="Storage">
      <div className={styles['container']}>
        <StorageProgress space={space} />

        {!space.isSelfServing && (
          <div className={styles['description-container']}>
            <p className={styles['description']}>
              To request additional storage, please contact{' '}
              <a href="mailto:sales@the-producer.io">sales@the-producer.io</a>
            </p>
          </div>
        )}
      </div>
    </SettingScreenLayout>
  );
});
